export const API_GET_ALL_SPECIALTY = 'API_GET_ALL_SPECIALTY'
export const API_GET_ALL_SPECIALTY_SUCCESS = 'API_GET_ALL_SPECIALTY_SUCCESS'
export const API_GET_ALL_SPECIALTY_FAIL = 'API_GET_ALL_SPECIALTY_FAIL'

export const API_ADMIN_GET_ALL_SPECIALTY = 'API_ADMIN_GET_ALL_SPECIALTY'
export const API_ADMIN_GET_ALL_SPECIALTY_SUCCESS = 'API_ADMIN_GET_ALL_SPECIALTY_SUCCESS'
export const API_ADMIN_GET_ALL_SPECIALTY_FAIL = 'API_ADMIN_GET_ALL_SPECIALTY_FAIL'

export const API_ADMIN_GET_SPECIALTY = 'API_ADMIN_GET_SPECIALTY'
export const API_ADMIN_GET_SPECIALTY_SUCCESS = 'API_ADMIN_GET_SPECIALTY_SUCCESS'
export const API_ADMIN_GET_SPECIALTY_FAIL = 'API_ADMIN_GET_SPECIALTY_FAIL'

export const API_ADMIN_POST_SPECIALTY = 'API_ADMIN_POST_SPECIALTY';
export const API_ADMIN_POST_SPECIALTY_SUCCESS = 'API_ADMIN_POST_SPECIALTY_SUCCESS';
export const API_ADMIN_POST_SPECIALTY_FAIL = 'API_ADMIN_POST_SPECIALTY_FAIL';

export const API_ADMIN_PATCH_SPECIALTY = 'API_ADMIN_PATCH_SPECIALTY';
export const API_ADMIN_PATCH_SPECIALTY_SUCCESS = 'API_ADMIN_PATCH_SPECIALTY_SUCCESS';
export const API_ADMIN_PATCH_SPECIALTY_FAIL = 'API_ADMIN_PATCH_SPECIALTY_FAIL';

export const API_ADMIN_DELETE_SPECIALTY = 'API_ADMIN_DELETE_SPECIALTY';
export const API_ADMIN_DELETE_SPECIALTY_SUCCESS = 'API_ADMIN_DELETE_SPECIALTY_SUCCESS';
export const API_ADMIN_DELETE_SPECIALTY_FAIL = 'API_ADMIN_DELETE_SPECIALTY_FAIL';

export const ADMIN_INIT_NEW_SPECIALTY = 'ADMIN_INIT_NEW_SPECIALTY'

export const ADMIN_RESET_FOCUS_SPECIALTY = 'ADMIN_RESET_FOCUS_SPECIALTY'